import {
  buffer,
  centroid,
  difference,
  Feature,
  intersect,
  MultiPolygon,
  Polygon,
  Position,
} from "@turf/turf";
import { Geometry } from "geojson";

export function getCutPolygon(
  overlayerPolygon: Feature<Polygon | MultiPolygon>,
  polygonToBeCut: Feature<Polygon | MultiPolygon>
) {
  const intersection = intersect(overlayerPolygon, polygonToBeCut);
  if (intersection) {
    const calculatedDifference = difference(polygonToBeCut, intersection);
    return calculatedDifference;
  }
  return undefined;
}

export function latLonToLonLat(lonLats: Position[][] | Position[][][]) {
  return lonLats.map((arrLvl0) =>
    arrLvl0.map((arrLvl1) => {
      if (isPosition(arrLvl1)) return [arrLvl1[1], arrLvl1[0]] as Position;
      return arrLvl1.map((arrLvl2) => [arrLvl2[1], arrLvl2[0]] as Position);
    })
  );
}

export function isPosition(
  coords: Position | Position[] | Position[][] | Position[][][]
): coords is Position {
  return typeof coords[0] === "number";
}

export function doPolygonsIntersect(
  overlayerPolygon: Feature<Polygon | MultiPolygon>,
  polygonToBeCut: Feature<Polygon | MultiPolygon>
) {
  const intersection = intersect(overlayerPolygon, polygonToBeCut);
  if (intersection) return intersection;
}

export function getCentroidPolygon(polygon: Geometry) {
  if (isPolygon(polygon)) {
    return centroid(polygon);
  }
  return null;
}

function isPolygon(polygon: Geometry): polygon is Polygon {
  // @ts-ignore
  return polygon.geometry.type === "Polygon";
}

export function calcBuffer(polygon: Geometry) {
  const bufferDistance = 100;
  const bufferUnit = "meters";

  const bufferedPolygon = buffer(polygon, bufferDistance, {
    units: bufferUnit,
  });
  return bufferedPolygon;
}
